<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-container>
        <div class="agent-view">
          {{agent}}
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AgentView',
  props: ['id'],
  computed: {
    agent () {
      return this.$store.getters.agentById(parseInt(this.$route.params.id))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agents/View.vue